import { render, staticRenderFns } from "./modal-delete.vue?vue&type=template&id=aa68029a&"
import script from "./modal-delete.vue?vue&type=script&lang=js&"
export * from "./modal-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports